import { FormikProps } from 'formik';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'src/store';
import { showToast } from 'src/utils/showToaster';
import {
  useAddDraftMutation,
  usePreviewInvoiceMutation,
} from '../service/POSServices';
import { calculatedAmounts } from './CartSummarySection';
import PaymentFormLayout from './PaymentFormLayout';
import { setPreviewData } from '../slice/CartSlice';
type Props = {
  onClose: () => void;
  items: any;
  customerId: any;
  formikProps: FormikProps<any>;
};

const PaymentFormWrapper = ({
  onClose,
  items,
  customerId,
  formikProps,
}: Props) => {
  const { outlet } = useSelector((state: RootState) => state.auth);
  const [addDraft, { isLoading: isDraftSubmitting }] = useAddDraftMutation();
  const [previewInvoice, { isLoading: previewIsLoading }] =
    usePreviewInvoiceMutation();
  const { previewData } = useSelector((state: RootState) => state.cart);
  // ✅ Subtotal (pre-discount)
const subtotal = Number(calculatedAmounts(items)?.totalAmount || 0);

// ✅ Discount (Formik se — CartSummarySection ne sync kiya hai)
const discount = formikProps?.values?.discount;
let discountAmount = 0;
if (discount && Number(discount.value) > 0) {
  if (discount.type === 'FLAT') {
    discountAmount = Math.min(Number(discount.value), subtotal);
  } else if (discount.type === 'PERCENTAGE') {
    discountAmount = Math.min(
      (subtotal * Number(discount.value)) / 100,
      subtotal
    );
  }
}

// ✅ Payable = final amount (after discount)
const payAbleAmount = Math.max(0, subtotal - discountAmount);
  const loyaltyPoints = customerId?.loyaltyPoints;
  const cashBackAmount = customerId?.cashBackAmount;
  const dispatch = useDispatch<AppDispatch>();
  const [isPreviewed, setIsPreviewed] = useState(false);

const handleApplyPayment = (values: any, setFieldValue: any) => {
  const formattedValues = {
    customerId: customerId?._id,
    // items: items?.map((item: any) => ({
    //   itemId: item?._id,
    //   quantity: item?.quantity,
    //   itemType: item?.type,
    // })),
     items: items?.map((item: any) => ({
      itemId: item?._id,
      quantity: item?.quantity,
      itemType: item?.type,
      sellingPrice: Number(item?.sellingPrice || 0), // ✅ Add karein
      ...(item?.type === 'SERVICE_GIFTCARD' && {
        isTempGiftCard: true,
        sellingPrice: Number(item.giftCardAmount || item.sellingPrice || 0)
      }),
    })),
    couponCode: values?.couponCode || '',
    shippingCharges: values?.shippingCharges || 0,
    giftCardCode: values?.giftCardCode || '',
    promotionCoupanCode: values?.promotionCoupanCode || '',
    rewardCoupan: values?.rewardCoupan || '',
    useLoyaltyPoints: values?.useLoyaltyPoints,
    useCashBackAmount: false,
    usedCashBackAmount: values?.usedCashBackAmount,
    referralCode: '',
    outletId: (outlet as any)?._id,

    discount: values?.discount || null,
    subtotal: Number(values?.subtotal || 0),
    discountAmount: Number(values?.discountAmount || 0),
    finalAmount: Number(values?.finalAmount || 0),
    amountReceived: (values?.amountReceived || []).map((p: any) => ({
      paymentModeId: p?.paymentModeId?._id || p?.paymentModeId || '',
      amount: String(p?.amount || '0.00'),
    })),

    notes: values?.notes || '',
  };

  console.log('-------formattedValues', formattedValues);

  previewInvoice(formattedValues).then((res: any) => {
    if (res?.error) {
      showToast('error', res?.error?.data?.message);
      return;
    }

    if (!res?.data?.status) return;

    const invoice = res?.data?.data;
    dispatch(setPreviewData(invoice));
    setIsPreviewed(true);

    // ✅ Backend ka final amount (post-discount)
    const serverFinalAmount = Number(invoice?.invoiceData?.totalAmount || 0);

    // ✅ AmountReceived ko server ke final amount se sync karo
    const existing = values?.amountReceived || [];

    if (existing.length <= 1) {
      // Single mode — server amount set
      setFieldValue('amountReceived', [
        {
          paymentModeId: existing[0]?.paymentModeId || '',
          amount: serverFinalAmount.toFixed(2),
        },
      ]);
    } else {
      // Multi mode — sum ko server amount se match karo (last entry adjust)
      const currentSum = existing.reduce(
        (s: number, p: any) => s + Number(p?.amount || 0),
        0
      );
      const diff = serverFinalAmount - currentSum;
      
      const updated = existing.map((p: any, i: number) => {
        if (i === existing.length - 1) {
          return {
            ...p,
            amount: Math.max(0, Number(p?.amount || 0) + diff).toFixed(2),
          };
        }
        return { ...p, amount: String(p?.amount || '0.00') };
      });
      
      setFieldValue('amountReceived', updated);
    }

    // ✅ finalAmount bhi Formik me server value se update karo
    setFieldValue('finalAmount', serverFinalAmount.toFixed(2));
  });
};

  const handleDraftdone = (formikProps: FormikProps<any>) => {
    formikProps.setFieldValue('items', []);
  };

  const handleDraft = (values: any) => {
    let formattedValues = {
      customerId: customerId?._id,
      items: items?.map((item: any) => {
        return {
          itemId: item?._id,
          quantity: item?.quantity,
          itemType: item?.type,
        };
      }),
      couponCode: values?.couponCode,
      shippingCharges: values?.shippingCharges || 0,
      amountReceived: [],
      giftCardCode: '',
      promotionCoupanCode: '',
      rewardCoupan: '',
      useLoyaltyPoints: values?.useLoyaltyPoints,
      referralCode: '',
      outletId: (outlet as any)?._id,
    };

    addDraft(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast('error', res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast('success', res?.data?.message);
          onClose();
          handleDraftdone(formikProps);
        } else {
          showToast('error', res?.data?.message);
        }
      }
    });
  };
  // console.log('payAbleAmount', payAbleAmount);

  return (
    <PaymentFormLayout
      previewData={previewData}
      handleApplyPayment={handleApplyPayment}
      onDraft={handleDraft}
      formikProps={formikProps}
      onClose={onClose}
      payAbleAmount={payAbleAmount}
      isPreviewed={isPreviewed}
      onModify={() => {
        setIsPreviewed(false), dispatch(setPreviewData(''));
      }}
      previewIsLoading={previewIsLoading}
      loyaltyPoints={loyaltyPoints}
      isDraftSubmitting={isDraftSubmitting}
      // cashBackAmount={cashBackAmount}
    />
  );
};

export default PaymentFormWrapper;
